import ArtPage from '../Art';
import HomePage from '../Home';
import NewsPage from '../News';
import HelpPage from '../Help';
import JobsPage from '../Jobs';
import LoginPage from '../Login';
import SearchPage from '../Search';
import AIPage from '../AI';
import LibraryPage from '../Library';
import BooksPage from '../Books';
import EBooksPage from '../EBooks';
import GalePage from '../Gale';
import PatentsPage from '../Patents';
import TutoringPage from '../Tutoring';
import TutorialsPage from '../Tutorial';
import InterestingLinksPage from '../InterestingLinks';
import AmericanLife from '../AmericanLife';
import VideoLibrary from '../VideoLibrary';
import DictionaryPage from '../Dictionary';
import ThesaurusPage from '../Thesaurus';
import MediaResourcesPage from '../MediaResources';
import NotFound from '../NotFound';
import SignUpPage from '../SignUp';
import RecoverPage from '../Recover';
import MyFavoritesPage from '../MyFavorites';
import FavoriteDetail from '../FavoriteDetail';
import SamlCallback from '../SamlCallback';
import D2lCallback from '../D2lCallback';
import GoogleCallback from '../GoogleCallback';
import LoginWordpressPage from '../LoginWordpress';

const appPages = [
	{
		path: '',
		title: 'Home',
		element: <HomePage />,
	},
	{
		path: '/login',
		title: 'Login',
		element: <LoginPage />,
	},
	{
		path: '/login-with-wordpress',
		title: 'Login With Wordpress',
		element: <LoginWordpressPage />,
	},
	{
		path: '/signup',
		title: 'Sign Up',
		element: <SignUpPage />,
	},
	{
		path: '/recover',
		title: 'Recover',
		element: <RecoverPage />,
	},
	{
		path: '/ai',
		title: 'Aquino AI',
		element: <AIPage />,
	},
	{
		path: '/search',
		title: 'Search',
		element: <SearchPage />,
	},
	{
		path: '/articles',
		title: 'Articles',
		element: <LibraryPage />,
	},
	{
		path: '/books',
		title: 'EBooks',
		element: <BooksPage />,
	},
	{
		path: '/ebooks',
		title: 'Spanish Resources',
		element: <EBooksPage />,
	},
	{
		path: '/gale',
		title: 'Gale',
		element: <GalePage />,
	},
	{
		path: '/dictionary',
		title: 'Dictionary',
		element: <DictionaryPage />,
	},
	{
		path: '/thesaurus',
		title: 'Thesaurus',
		element: <ThesaurusPage />,
	},
	{
		path: '/interesting-links',
		title: 'Interesting  Links',
		element: <InterestingLinksPage />,
	},
	{
		path: '/tutorials',
		title: 'Tutorials',
		element: <TutorialsPage />,
	},
	{
		path: '/tutoring',
		title: 'Tutoring',
		element: <TutoringPage />,
	},
	{
		path: '/news',
		title: 'News',
		element: <NewsPage />,
	},
	{
		path: '/help',
		title: 'Help',
		element: <HelpPage />,
	},
	{
		path: '/media',
		title: 'Media',
		element: <MediaResourcesPage />,
	},
	{
		path: '/patents',
		title: 'Patents',
		element: <PatentsPage />,
	},
	{
		path: '/jobs',
		title: 'Jobs',
		element: <JobsPage />,
	},
	{
		path: '/american-life',
		title: 'Amelican life',
		element: <AmericanLife />,
	},
	{
		path: '/video-library',
		title: 'Video Library',
		element: <VideoLibrary />,
	},
	{
		path: '/art',
		title: 'Art',
		element: <ArtPage />,
	},
	{
		path: '/my-favorites',
		title: 'My favorites',
		element: <MyFavoritesPage />,
	},
	{
		path: '/favorites',
		title: 'Favorite Category',
		element: <FavoriteDetail />,
	},
	{
		path: '/saml-callback',
		title: 'SAML-callback',
		element: <SamlCallback />,
	},
	{
		path: '/d2l-callback',
		title: 'D2L-callback',
		element: <D2lCallback />,
	},
	{
		path: '/google-callback',
		title: 'Google-callback',
		element: <GoogleCallback />,
	},
	{
		path: '*',
		title: '*',
		element: <NotFound />,
	},
];

export default appPages;
